import * as React from 'react';
import { IPage } from '../../global/state-helpers/page';
import { IPaginatedLandingContent } from '../models/paginated-landing-content'
import { Pagination, IPaginationOptions } from '../../global/components/pagination/pagination';
import { ContentList } from './paginated-landing-content-list';
import PaginatedFilters from './paginated-filters';
import * as queryString from 'query-string'
import { ConnectedSearchBar } from '../../global/components/inputs/search-bar/search-bar';
import { Textbox } from '../../global/components/inputs/textbox/textbox';
import { getResultsText } from '../../global/actions/results-count';
import { ResultsCountMessage } from '../../global/components/results/results-count-msg';
import { ResultsProps } from '../../global/state-helpers/site-settings-props';
import { filter, forEach } from 'lodash';
import matchesAnyTopicHelper from '../matchesAnyTopicHelper';
import matchesAnyRoleHelper from '../matchesAnyRoleHelper';
import { Countries } from '../../membership-application/constants/constants';
import matchesAnyAgeHelper from '../matchesAnyAgeHelper';

export interface FiltersData {
    RoleHeading: string;
    TopicHeading: string;
    AgeRangesHeading: string;
    TopicFilters: Filter[];
    RoleFilters: Filter[];
    AgeRangesFilters: Filter[];
    ShowRoleFilter: boolean;
    ShowTopicFilter: boolean;
    ShowAgeRangesFilter: boolean;
    items: IPaginatedLandingContent[];
    DefaultTopicFilterSize: number;
    DefaultRoleFilterSize: number;
    DefaultAgeRangesFilterSize: number;
}

export type Filter = Record<string, string>

interface IProps {
    items: IPaginatedLandingContent[];
    pageModel: IPage;
    searchText: string;
    filtersData: FiltersData;
    topicFilter: Filter[];
    roleFilter: Filter[];
    ageFilter: Filter[];
    activeFilter: boolean;
    updateTopicFilterCount: (filterIndex: number, newCount: number) => void;
    updateRoleFilterCount: (filterIndex: number, newCount: number) => void;
    updateAgeFilterCount: (filterIndex: number, newCount: number) => void;
}

// Internal state of the component
interface IState {
    loading: boolean;
    errorText: string;
    currentPage?: number;
    searchText: string;
    inputText: string;
    showMobileFacets: boolean;
    filteredArray: IPaginatedLandingContent[];
}

export class PaginatedLandingContent extends React.Component<IProps, IState> {
    state: IState = {
        currentPage: this.props.pageModel.page,
        loading: true,
        errorText: null,
        inputText: this.props.searchText,
        searchText: this.props.searchText ? this.props.searchText : "",
        showMobileFacets: false,
        filteredArray: []
    }

    render() {
        const pagination = {
            totalItems: this.state.filteredArray.length,
            currentPage: this.state.currentPage,
            pageSize: this.props.pageModel.pageSize,
        } as IPaginationOptions;



        return (
            <>
                <div className="paginated-container">
                    <div className={"paginated-filters-container " + (this.state.showMobileFacets ? 'active' : '')}>
                        <button className="paginated-filters-header paginated-filters-header-mobile search-facet-header un-button" type="button" onClick={this.toggleMobileFacets}>
                            <p className="h4-styled no-margin"> Filters </p>
                            <svg className="open">
                                <use xlinkHref="#arrow-down"></use>
                            </svg>
                        </button>

                        <PaginatedFilters filtersData={this.props.filtersData} updateRoleFacet={this.updateRoleFacetCounts} updateTopicFacet={this.updateTopicFacetCounts} />
                    </div>

                    <div className="paginated">
                        <div className="keyword-search">
                            <Textbox
                                id="content-landing-search-input"
                                value={this.state.inputText}
                                onInput={(e) => this.onInputChange(e.currentTarget.value)}
                                onKeyPress={this.onKeyPress}
                                isControlled={true}
                                placeHolder="Search"

                            />
                            <button
                                className="global-search-bar-button button-primary search-box-text"
                                onClick={this.onSearch}>
                                Search
                            </button>
                        </div>
                        <div className="keyword-search-count">
                            {this.renderShowingMessage(this.props.pageModel, pagination)}
                        </div>
                        <ContentList
                            items={this.state.filteredArray}
                            currentPage={this.state.currentPage}
                            pageSize={pagination.pageSize}
                            searchText={this.state.inputText}
                        />
                        <Pagination
                            pagination={pagination}
                            onPageSelect={(page: number) => this.onPageSelect(page, true)}
                            useRedux={false} />
                    </div>
                </div>
            </>
        )
    }


    componentDidMount() {
        this.setState({ ...this.state, filteredArray: this.getFilteredItems() })
    }

    componentDidUpdate(prevProps: IProps, prevState) {
        if (prevProps.roleFilter.length !== this.props.roleFilter.length) {
            this.getFilteredItems();
            this.updateTopicFacetCounts();
            this.updateAgeFacetCounts();
        }
        if (prevProps.topicFilter.length !== this.props.topicFilter.length) {
            this.getFilteredItems();
            this.updateRoleFacetCounts();
            this.updateAgeFacetCounts();
        }
        if (prevProps.ageFilter.length !== this.props.ageFilter.length) {
            this.getFilteredItems();
            this.updateTopicFacetCounts();
            this.updateRoleFacetCounts();
        }
        if (prevState.searchText !== this.state.searchText) {
            var url = `?${queryString.stringify({ page: 1, q: this.state.searchText }, { sort: false })}`
            window.history.replaceState(undefined, undefined, url);
            this.getFilteredItems();
            this.updateRoleFacetCounts();
            this.updateTopicFacetCounts();
            this.updateAgeFacetCounts();
        }
    }
    

    onSearch = () => {
        this.setState(prevState => ({ searchText: prevState.inputText, currentPage: 1 }));      
    }
    

    onInputChange = (value: string) => {
        this.setState(state => ({ ...state, inputText: value, currentPage: 1 }));

        var url = `?${queryString.stringify({ page: 1, q: value }, { sort: false })}`
        window.history.replaceState(undefined, undefined, url);
    }

    onKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.onSearch();
        }
    }

    onPageSelect = (page: number, scrollToTop: boolean = false) => {

        this.setState({ currentPage: page });

        if (scrollToTop) {
            window.scroll(0, 0);
        }

        var url = `?${queryString.stringify({ page: page, q: this.state.inputText }, { sort: false })}`
        window.history.replaceState(undefined, undefined, url);
    }

    filterSearchItems = (item: IPaginatedLandingContent, searchText: string): boolean => {
        // If there is no search text, every item is in the list
        if (!searchText) {
            return true;
        }

        // Actual filtering by title and description
        return (item.title != null && item.title.toLowerCase().indexOf(searchText.toLowerCase()) >= 0) ||
            (item.description != null && item.description.toLowerCase().indexOf(searchText.toLowerCase()) >= 0);
    }

    getFilteredItems() {
        let searchResultItems = this.props.items.filter(i => this.filterSearchItems(i, this.state.searchText));
        let resultsArray: IPaginatedLandingContent[];
        // Check if any facets are selected, otherwise return all results array 
        if (this.props.roleFilter.length > 0 || this.props.topicFilter.length > 0 || this.props.ageFilter.length > 0) {

            const activeRoleFilter = this.props.roleFilter.length > 0;
            const activeTopicFilter = this.props.topicFilter.length > 0;
            const activeAgeFilter = this.props.ageFilter.length > 0;

            // If there's an active filter, start fresh with a new results array
            let filteredArray = [];

            // With each item from search results, check against all topics
            searchResultItems.forEach((result) => {
                let matchesRole, matchesTopic, matchesAge;

                matchesRole = activeRoleFilter ? matchesAnyRoleHelper(result, this.props.roleFilter) : true;
                matchesTopic = activeTopicFilter ? matchesAnyTopicHelper(result, this.props.topicFilter) : true;
                matchesAge = activeAgeFilter ? matchesAnyAgeHelper(result, this.props.ageFilter) : true;

                // If both are undefined, then it matches
                if (this.matchesCombinedFilters(!!matchesTopic, !!matchesRole, !!matchesAge)) {
                    filteredArray.push(result);
                }
            })

            resultsArray = filteredArray;
        }

        else {
            resultsArray = searchResultItems;
        }
        this.setState(prevState => ({ ...this.state, filteredArray: resultsArray }));
        return resultsArray;
    }

    matchesCombinedFilters(matchesTopic: boolean, matchesRole: boolean, matchesAge: boolean) {
        return matchesTopic && matchesRole && matchesAge;
    }

    updateTopicFacetCounts = () => {
        //this code if both are selected else use the entire search list
        const baseArray = this.props.items.filter(i => this.filterSearchItems(i, this.state.searchText));
        let countArray = [];
        let roleArray = [];
        let ageArray = [];
        if (this.props.roleFilter.length > 0 || this.props.ageFilter.length > 0) {
            if (this.props.roleFilter.length > 0) {
                // set the filtered Array equal to the filtered out roles cant use getfiltereditems because it filters on both at once and you will miss items depending on the order it checks 
                
                this.props.roleFilter.forEach(filter => {
                    let matchedFilters = baseArray.filter(item => {
                        if (item.roles) {
                            return item.roles.map(role => role.toLowerCase()).includes(filter.name.toLowerCase());
                        }
                    
                    });
                    matchedFilters.forEach(match => {
                        if (!roleArray.includes(match)) {
                            roleArray.push(match);
                        }
                    });
                    countArray = roleArray;
                })
            }
            if (this.props.ageFilter.length > 0) {
                
                // push filtered out ages
                this.props.ageFilter.forEach(filter => {
                    let matchedFilters = baseArray.filter(item => {
                        if (item.ages) {
                            return item.ages.map(age => age.toLowerCase()).includes(filter.name.toLowerCase());
                        }

                    });
                    matchedFilters.forEach(match => {
                        if (!ageArray.includes(match)) {
                            ageArray.push(match);
                        }
                    });
                    countArray = ageArray;
                })
            }
            // now that we added a third filter we need to check the previous two prefiltered categories in this case roles and age and only push the items that are in both arrays to do the final check for counts on the filter otherwise we rely on the countArray = to be correct knowing that only one would be hit
            if (this.props.ageFilter.length > 0 && this.props.roleFilter.length > 0) {
                countArray = roleArray.filter(filteredItem => ageArray.includes(filteredItem));
            }
        }
        else { countArray = baseArray; }
            this.props.filtersData.TopicFilters.forEach((filterOption, index) => {

                const matches = countArray.filter((result) => {

                    if (result.topics) {
                        let count = 0
                        result.topics.forEach((topic) => {
                            if (topic.toLowerCase() == filterOption.Key.toLowerCase()) {
                                count++;
                            }
                        })
                        if (count > 0) {
                            return true;
                        }
                    }
                    return false;
                })

                this.props.updateTopicFilterCount(index, matches.length)
        })
    }

    updateRoleFacetCounts = () => {
        // this code if both are selected
        const baseArray = this.props.items.filter(i => this.filterSearchItems(i, this.state.searchText));
        let countArray = [];
        let topicArray = [];
        let ageArray = [];
        if (this.props.topicFilter.length > 0 || this.props.ageFilter.length > 0) {
            if (this.props.topicFilter.length > 0) {
                // set the countArray equal to the filtered out roles and then match against that cant use getfiltereditems because it filters on both at once and you will miss items depending on the order it checks
                this.props.topicFilter.forEach(filter => {
                    let matchedFilters = baseArray.filter(item => {
                        if (item.topics) {
                            return item.topics.map(topic => topic.toLowerCase()).includes(filter.name.toLowerCase());
                        }
                    });
                    matchedFilters.forEach(match => {
                        if (!topicArray.includes(match)) {
                            topicArray.push(match);
                        }
                    });
                    countArray = topicArray;
                })
            }
            if (this.props.ageFilter.length > 0) {
                // push filtered out ages
                this.props.ageFilter.forEach(filter => {
                    let matchedFilters = baseArray.filter(item => {
                        if (item.ages) {
                            return item.ages.map(age => age.toLowerCase()).includes(filter.name.toLowerCase());
                        }

                    });
                    matchedFilters.forEach(match => {
                        if (!ageArray.includes(match)) {
                            ageArray.push(match);
                        }
                    });
                    countArray = ageArray;
                })
            }
            if (this.props.ageFilter.length > 0 && this.props.topicFilter.length > 0) {
                countArray = topicArray.filter(filteredItem => ageArray.includes(filteredItem));
            }
        }
        else { countArray = baseArray; }
            this.props.filtersData.RoleFilters.forEach((filterOption, index) => {
                const matches = countArray.filter((result) => {

                    if (result.roles) {
                        let count = 0
                        result.roles.forEach((role) => {
                            if (role.toLowerCase() == filterOption.Key.toLowerCase()) {
                                count++;
                            }
                        })
                        if (count > 0) {
                            return true;
                        }
                    }
                    return false;
                })

                this.props.updateRoleFilterCount(index, matches.length)
            })


    }
    updateAgeFacetCounts = () => {
        // this code if both are selected
        const baseArray = this.props.items.filter(i => this.filterSearchItems(i, this.state.searchText));
        let countArray = [];
        let roleArray = [];
        let topicArray = [];
        if (this.props.topicFilter.length > 0 || this.props.roleFilter.length > 0) {
            if (this.props.topicFilter.length > 0) {
                // set the countArray equal to the filtered out roles and then match against that cant use getfiltereditems because it filters on both at once and you will miss items depending on the order it checks
                this.props.topicFilter.forEach(filter => {
                    let matchedFilters = baseArray.filter(item => {
                        if (item.topics) {
                            return item.topics.map(topic => topic.toLowerCase()).includes(filter.name.toLowerCase());
                        }
                    });
                    matchedFilters.forEach(match => {
                        if (!topicArray.includes(match)) {
                            topicArray.push(match);
                        }
                    });
                    countArray = topicArray;
                })
            }
            if (this.props.roleFilter.length > 0) {
                // set the countArray equal to the filtered out roles and then match against that cant use getfiltereditems because it filters on both at once and you will miss items depending on the order it checks
                this.props.roleFilter.forEach(filter => {
                    let matchedFilters = baseArray.filter(item => {
                        if (item.roles) {
                            return item.roles.map(role => role.toLowerCase()).includes(filter.name.toLowerCase());
                        }

                    });
                    matchedFilters.forEach(match => {
                        if (!roleArray.includes(match)) {
                            roleArray.push(match);
                        }
                    });
                    countArray = roleArray;
                })
            }
            if (this.props.roleFilter.length > 0 && this.props.topicFilter.length > 0) {
                countArray = topicArray.filter(filteredItem => roleArray.includes(filteredItem));
            }
        }
        else { countArray = baseArray; }

        this.props.filtersData.AgeRangesFilters.forEach((filterOption, index) => {
            const matches = countArray.filter((result) => {

                if (result.ages) {
                    let count = 0
                    result.ages.forEach((age) => {
                        if (age.toLowerCase() == filterOption.Key.toLowerCase()) {
                            count++;
                        }
                    })
                    if (count > 0) {
                        return true;
                    }
                }
                return false;
            })

            this.props.updateAgeFilterCount(index, matches.length)
        })


    }



    renderShowingMessage = (page: IPage, pagination: IPaginationOptions): JSX.Element => {
        let beginNumber = ((pagination.currentPage - 1) * page.pageSize) + 1;
        let endNumber = page.pageSize * pagination.currentPage < pagination.totalItems ? page.pageSize * pagination.currentPage : pagination.totalItems;
        let ofNumber = pagination.totalItems;
        let message = ofNumber === 0 ? 'No Results' : `Showing ${beginNumber} - ${endNumber} of ${ofNumber}`

        return (
            <div>
                {message}
            </div>
        )
    }





    toggleMobileFacets = () => {
        this.setState({ showMobileFacets: !this.state.showMobileFacets });
    }
}